import dynamic from "next/dynamic";
import { DynamicImageViewInterface } from "components/common/DynamicImageView/DynamicImageViewInternal";

const DynamicImageViewInternal = dynamic<DynamicImageViewInterface>(
    () =>
        import("components/common/DynamicImageView/DynamicImageViewInternal").then(
            (mod) => mod.DynamicImageViewInternal,
        ),
    {
        ssr: false,
    },
);

export const DynamicImageView = (props: DynamicImageViewInterface) => {
    return <DynamicImageViewInternal {...props} />;
};
